import { useEffect, useState } from 'react';

const useMediaQuery = (query, defaultValue = false) => {
  const [matches, setMatches] = useState(defaultValue);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleMediaQueryChange = (e) => setMatches(e.matches);

    setMatches(mediaQuery.matches);

    mediaQuery.addEventListener('change', handleMediaQueryChange);

    return () => mediaQuery.removeEventListener('change', handleMediaQueryChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return matches;
};

export default useMediaQuery;
